import { render, staticRenderFns } from "./RelatoriosManutencaoN.vue?vue&type=template&id=0515abdf&scoped=true&"
import script from "./RelatoriosManutencaoN.vue?vue&type=script&lang=js&"
export * from "./RelatoriosManutencaoN.vue?vue&type=script&lang=js&"
import style0 from "./RelatoriosManutencaoN.vue?vue&type=style&index=0&id=0515abdf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0515abdf",
  null
  
)

export default component.exports